import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from '@/router'
import AppConfig from '@/app.config.js'

Vue.use(AclInstaller)

let initialRole = 'Public'
if (localStorage.getItem(AppConfig.auth.userRole))
  initialRole = localStorage.getItem(AppConfig.auth.userRole)

export default new AclCreate({
  initial: initialRole,
  notfound: '/error-404',
  router,
  acceptLocalRules: true,
  globalRules: {
    admin: new AclRule('Admin').generate(),

    member: new AclRule('Member').generate(),

    loggedin: new AclRule('Admin')
      .or('Member')
      .generate(),

    public: new AclRule('Public')
      .or('Admin')
      .or('Member')
      .generate(),
  }
})
